var _ = require('lodash');

(function Module() {
	'use strict';

	mySynch.directive('tabset', function tabset() {
		return {
			restrict: 'E',
			replace: true,
			transclude: true,
			controller: function tabsetController() {
				var self = this;
				var tabs = self.tabs = [];
				self.templateUrl = '';

				self.selectTab = function selectTab(tab) {
					_.forEach(tabs, function eachTab(tab) {
						tab.selected = false;
					});
					tab.selected = true;
				};

				self.setTabTemplate = function setTabTemplate(templateUrl) {
					self.templateUrl = templateUrl;
				};

				self.addTab = function addTab(tab) {
					if (!tabs.length) {
						self.selectTab(tab);
					}
					tabs.push(tab);
				};
			},
			controllerAs: 'tabsetCtrl',
			template:
				'<div>' +
					'<div class="row-fluid">' +
						'<div class="nav nav-tabs nav-justified" ng-transclude></div>' +
					'</div>' +
					'<div class="row-fluid tab-content">' +
						'<ng-include src="tabsetCtrl.templateUrl"></ng-include>' +
					'</div>' +
				'</div>'
		};
	})
	.directive('tab', [
		'MySynchFactory',
		function tab(MSF) {
			return {
				restrict: 'E',
				replace: true,
				require: '^tabset',
				scope: {
					title: '@',
					templateUrl: '@'
				},
				link: function tabLink(scope, element, attrs, tabsetController) {
					tabsetController.addTab(scope);

					scope.select = function select() {
						var formCtrl = scope.$parent.farmDetailsCtrl || scope.$parent.fcpCtrl || {};
						var formOnPage =
							formCtrl.demographicsForm ||
							formCtrl.breedingCodesForm ||
							formCtrl.costForm ||
							formCtrl.adminForm ||
							formCtrl.commonForm ||
							formCtrl.lactation1Form ||
							formCtrl.lactation2Form;

						if (formCtrl.commonForm && scope.$parent.fcpExports.isNewProgram) {
							return MSF.notify.danger('Please save changes or choose a saved program.');
						}

						if (formOnPage && !formOnPage.$pristine) {
							MSF.confirm('unsavedChanges', function confirmed() {
								tabsetController.selectTab(scope);

								scope.$apply();
							});

							return false;
						}

						return tabsetController.selectTab(scope);
					};

					scope.$watch('selected', function watchSelected() {
						if (scope.selected) {
							tabsetController.setTabTemplate(scope.templateUrl);
						}
					});
				},
				template:
					'<li ng-class="{active: selected}">' +
					'<a href="" ng-click="select()">{{ title }}</a>' +
					'</li>'
			};
		}
	]);
})();
